var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilledFav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "filled_fav") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_line_style_24px",
    transform: "translate(-1431 -13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3697",
    "data-name": "Rectangle 3697",
    width: 24,
    height: 24,
    transform: "translate(1431 13)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "star_FILL1_wght400_GRAD0_opsz24",
    d: "M5.825,22,7.45,14.975,2,10.25l7.2-.625L12,3l2.8,6.625,7.2.625-5.45,4.725L18.175,22,12,18.275Z",
    transform: "translate(1431 13)",
    fill: "#21a2ee"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledFav);
export default __webpack_public_path__ + "static/media/filled_fav.5bbaaf879473b004486ff98373c4f21c.svg";
export { ForwardRef as ReactComponent };